module.exports = __webpack_public_path__ + "img/points.205624b5.svg";